import React, { createContext, useContext, useState } from "react";
import { Observer, observer } from "mobx-react-lite";
import { Table, List, Typography, Modal, Tag, Skeleton, Space, Button, notification } from "antd";
import { toJS } from "mobx";
import TextArea from "antd/lib/input/TextArea";
import { ProgressIndicator, MessageBar, MessageBarType } from "@fluentui/react";
import moment from "moment";

import { changeRequestStore } from "../../store/ChangeRequestStore";
import { authStore } from "../../../../../Home/store/AuthStore";
import { platformStore } from "../../../../store/platformStore";
import { IChangeView, IChangesTableData } from "../../types/interface";
import { ColumnsType } from "antd/lib/table";

const _ = require("underscore");
const { Paragraph, Title } = Typography;
const changeRequestStoreCtx = createContext(changeRequestStore);
const platformStoreCtx = createContext(platformStore);
const authStoreCtx = createContext(authStore);

function DeclineRequestDialog() {
    const ChangeRequestStore = useContext(changeRequestStoreCtx);
    const PlatformStore = useContext(platformStoreCtx);
    const AuthStore = useContext(authStoreCtx);

    const [reason, setReason] = useState("");

    const columns: ColumnsType<IChangesTableData> = [
        {
            title: 'ModifiedField',
            dataIndex: 'modifiedField',
            render: (text: any, record: any, index: any) => {
                let ret = record.modifiedField === "nextRankId"
                    ? <a>{"NextRank"}</a>
                    : record.modifiedField === "rankId"
                        ? <a>{"Rank"}</a>
                        : record.modifiedField === "nationality1Id"
                            ? <a>{"Nationality1"}</a>
                            : record.modifiedField === "nationality2Id"
                                ? <a>{"Nationality2"}</a>
                                : record.modifiedField === "professionId"
                                    ? <a>{"Profession"}</a>
                                    : record.modifiedField === "qualificationId"
                                        ? <a>{"Qualification"}</a>
                                        : record.modifiedField === "branchId"
                                            ? <a>{"Branch"}</a>
                                            : record.modifiedField === "bandId"
                                                ? <a>{"Band"}</a>
                                                : record.modifiedField === "principalBandId"
                                                    ? <a>{"PrincipalBand"}</a>
                                                    : <a>{text}</a>
                return ret;
            }
        },
        {
            title: 'Value',
            dataIndex: 'fieldValue',
            render: (text: any, record: any, index: any) => {
                let ret = (record.modifiedField === "ordinationRankOfSpouse" || record.modifiedField === "nextRankId")
                    ? PlatformStore.ranks.get(Number(record.fieldValue))?.rankName
                    : record.modifiedField === "rankId"
                        ? PlatformStore.ranks.get(Number(record.fieldValue))?.rankName
                        : (record.modifiedField === "nationality1Id" || record.modifiedField === "nationality2Id")
                            ? PlatformStore.nationalities.get(Number(record.fieldValue))?.nationalityName
                            : record.modifiedField === "professionId"
                                ? PlatformStore.professions.get(Number(record.fieldValue))?.professionName
                                : record.modifiedField === "qualificationId"
                                    ? PlatformStore.qualifications.get(Number(record.fieldValue))?.qualificationName
                                    : record.modifiedField === "branchId"
                                        ? PlatformStore.branchs.get(Number(record.fieldValue))?.branchName
                                        : record.modifiedField === "bandId"
                                            ? PlatformStore.bands.get(Number(record.fieldValue))?.bandName
                                            : record.modifiedField === "principalBandId"
                                                ? PlatformStore.principalBands.get(Number(record.fieldValue))?.principalBandName
                                                : text
                return ret;
            }
        },
    ];

    const data = [
        {
            title: "",
            description: (
                <MessageBar messageBarType={MessageBarType.warning}>
                    <b>Warning:</b> You are declining this member's information update request.
                </MessageBar>
            ),
        },
        {
            title: "Changes Type",
            description: (
                <Tag
                    color={
                        ChangeRequestStore.selectedChangeRequest.changesType === "Profile"
                            ? "blue"
                            : ChangeRequestStore.selectedChangeRequest.changesType === "Ordination"
                                ? "#d92525"
                                : "green"
                    }
                    title={ChangeRequestStore.selectedChangeRequest.changesType}
                >
                    {ChangeRequestStore.selectedChangeRequest.changesType}
                </Tag>
            ),
        },
        {
            title: "Full Name",
            description: ChangeRequestStore.selectedChangeRequest.fullName,
        },
        {
            title: "Request Date",
            description: moment(ChangeRequestStore.selectedChangeRequest.createdOn).format("ddd Do MMM YYYY"),
        },
        {
            title: "",
            description: (
                <Table
                    style={{ width: "100%" }}
                    size='large'
                    loading={ChangeRequestStore.isLoadingTDAta}
                    bordered
                    columns={columns}
                    dataSource={[...ChangeRequestStore.selectedChangesTableData.values()].map((row) =>
                        toJS(row)
                    )}
                    pagination={false}
                />
            ),
        },
    ];

    const handleDecline = async () => {
        if (!reason || reason.trim().length < 10) {
            notification.warning({
                message: "EDataBank Platform Feedback",
                description: "Please provide a decline reason (minimum 10 characters)",
            });
            return;
        }

        try {
            await ChangeRequestStore.declineChange(
                ChangeRequestStore.selectedChangeRequest.changesRequestId,
                AuthStore.currentUser.id,
                reason
            );

            notification.success({
                message: "EDataBank Platform Feedback",
                description: "Request declined successfully",
            });

            // Reset and close
            setReason("");
            ChangeRequestStore.selectedChangeRequest = {} as IChangeView;
            ChangeRequestStore.showDeclineDialog = false;
            ChangeRequestStore.selectedChangesTableData.clear();

            // Refresh the list
            await ChangeRequestStore.getAllChangeRequest();
        } catch (error) {
            notification.error({
                message: "EDataBank Platform Feedback",
                description: (error as any).response?.body?.msg || "An error occurred during decline",
            });
        }
    };

    const handleCancel = () => {
        setReason("");
        ChangeRequestStore.showDeclineDialog = false;
        ChangeRequestStore.selectedChangesTableData.clear();
    };

    return (
        <Modal
            open={ChangeRequestStore.showDeclineDialog}
            width={"30%"}
            title={`Decline ${ChangeRequestStore.selectedChangeRequest.changesType} Update Request`}
            onCancel={handleCancel}
            destroyOnClose={true}
            footer={false}
            maskClosable={false}
        >
            <div className="ms-Grid-row">
                <div className="ms-Grid-col md-12">
                    {ChangeRequestStore.isLoadingTDAta ? (
                        <>
                            <Skeleton active />
                            <Skeleton active />
                            <Skeleton active />
                            <Skeleton active />
                            <Skeleton active />
                        </>
                    ) : (
                        <>
                            <List
                                itemLayout="horizontal"
                                dataSource={data}
                                renderItem={(item) => (
                                    <List.Item>
                                        <List.Item.Meta
                                            title={<a href="/#">{item.title}</a>}
                                            description={item.description}
                                        />
                                    </List.Item>
                                )}
                            />

                            <div style={{ marginTop: "20px" }}>
                                <label><b>Decline Reason (Required)*:</b></label>
                                <TextArea
                                    rows={4}
                                    placeholder="Enter reason for declining this request (minimum 10 characters)"
                                    value={reason}
                                    onChange={(e) => setReason(e.target.value)}
                                    style={{ marginTop: "8px" }}
                                    status={reason.trim().length > 0 && reason.trim().length < 10 ? "error" : ""}
                                />
                                {reason.trim().length > 0 && reason.trim().length < 10 && (
                                    <div style={{ color: "#ff4d4f", marginTop: "4px", fontSize: "12px" }}>
                                        Minimum 10 characters required
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                </div>

                <div style={{ paddingTop: "20px", textAlign: "right", width: "100%" }}>
                    <Space>
                        <Button onClick={handleCancel}>
                            Cancel
                        </Button>
                        <Button
                            type="primary"
                            danger
                            onClick={handleDecline}
                            loading={ChangeRequestStore.isLoading}
                            disabled={!reason || reason.trim().length < 10}
                        >
                            Decline Request
                        </Button>
                    </Space>
                </div>

                <Observer>
                    {() => (
                        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg6">
                            {ChangeRequestStore.isLoading && (
                                <ProgressIndicator
                                    description="Declining request..."
                                    styles={{ root: { textAlign: "center" } }}
                                />
                            )}
                        </div>
                    )}
                </Observer>
            </div>
        </Modal>
    );
}

export default observer(DeclineRequestDialog);
